var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "map-offcanvas__item" }, [
    _vm._m(0),
    _vm.custom_layers_list
      ? _c("div", { staticClass: "map-offcanvas__body" }, [
          _c(
            "div",
            { staticClass: "uk-padding-small uk-padding-remove-vertical" },
            [
              _c(
                "ul",
                {
                  staticClass: "uk-list uk-margin-remove",
                  attrs: { "uk-accordion": "" }
                },
                _vm._l(_vm.custom_layers_list, function(
                  custom_layers,
                  area_name
                ) {
                  return _c("li", { key: "area_" + area_name }, [
                    _c(
                      "a",
                      {
                        staticClass: "uk-accordion-title",
                        attrs: { href: "#" }
                      },
                      [
                        _c("div", { staticClass: "uk-flex uk-flex-middle" }, [
                          _c("span", [_vm._v(_vm._s(area_name) + " ")]),
                          _c("span", { staticClass: "uk-badge" }, [
                            _vm._v(_vm._s(custom_layers.length))
                          ])
                        ])
                      ]
                    ),
                    _c("div", { staticClass: "uk-accordion-content" }, [
                      _c(
                        "ul",
                        { staticClass: "uk-list uk-list-square" },
                        _vm._l(custom_layers, function(custom_layer) {
                          return _c(
                            "li",
                            { key: "custom_layer_" + custom_layer.props.id },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.handlePopup(custom_layer)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(custom_layer.props.name))]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                }),
                0
              )
            ]
          )
        ])
      : _c("div", { staticClass: "map-offcanvas__body" }, [
          _vm._v("現在公開中の情報はありません。")
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "map-offcanvas__title" }, [
      _c("span", { attrs: { "uk-icon": "icon: location; ratio: .7" } }),
      _c("div", [_vm._v(" 災害情報")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }